<template>
  <div>
    <div class="page-content container-fluid">
      <div class="card">
        <div class="card-body">
          <form @submit.prevent="submit">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">WhatsApp</label>

              <div class="col-sm-10">
                <input v-model="accountManager.contactInfo.whatsapp" type="text" class="form-control" required/>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Booking link</label>

              <div class="col-sm-10">
                <input v-model="accountManager.contactInfo.calendar" type="text" class="form-control" required/>
              </div>
            </div>
            <div class="hr-line-dashed"></div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Account manager</label>

              <div class="col-sm-10">
                <b-form-select v-model="accountManager.userId" :options="adminUsers" required></b-form-select>
              </div>
            </div>

            <div v-if="accountManager.userId" class="form-group row">
              <label class="col-sm-2 col-form-label">Is deleted</label>
              <div class="col-sm-10">
                <div class="d-flex align-items-center">
                  <input v-model="accountManager.delete" type="checkbox" style="margin-top: 8px;"/>
                </div>
              </div>
            </div>
            

            <div class="text-center form-group">
              <button class="btn btn-primary btn-sm" type="button" @click="backView">Cancel</button>
              <button
                  class="btn btn-primary btn-sm"
                  type="submit"
                  style="margin-left: 10px"
              >Save changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bodyTextOrRef } from '@/apiErrorRef'
import Config from '@/config'

export default {
  name: "AccountManagerDetails",
  data() {
    return {
      id: "",
      accountManager: {
        contactInfo: {
          whatsapp: "",
          calendar: ""
        },
        userId: null
      },
      adminUsers: [],
      adminUsersEmailSet: null,
      adminUsersUserIdSet: null,
      submiting: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.id = this.$route.params.id

      await this.$http.get(Config.api.getAdminUsers).then(
          res => {
            this.adminUsers = res.body.users.map(user => user.email)
            const userByEmail = new Map()
            const userByUserId = new Map()
            res.body.users.forEach(user => {
              userByEmail.set(user.email, user)
              userByUserId.set(user.id, user)
            })
            this.adminUsersEmailSet = userByEmail
            this.adminUsersUserIdSet = userByUserId
          }
      )

      if (this.id != "new") {
        this.$http.get(`${Config.api.accountManager}/${this.id}`).then(
            res => {
              const accountManager = res.body.accountManager
              const user = this.adminUsersUserIdSet.get(accountManager.userId)
              accountManager.userId = user ? user.email : null
              this.accountManager = accountManager
            },
            () => {
              this.$router.push({name: "AccountManagerList"})
            }
        )
      }
    },
    submit() {
      if (this.submiting) return
      this.submiting = true

      if (this.accountManager.userId && this.adminUsersEmailSet.has(this.accountManager.userId)) {
        this.accountManager.userId = this.adminUsersEmailSet.get(this.accountManager.userId).id
      }

      if (this.id == "new") {
        this.$http.post(Config.api.accountManager, this.accountManager).then(
            () => {
              this.submiting = false
              this.$router.push({name: "AccountManagerList"})
              this.$toasted.success("Created!")
            },
            err => {
              this.submiting = false
              this.$toasted.error(bodyTextOrRef(err))
            }
        )
      } else {
        this.$http.patch(`${Config.api.accountManager}/${this.id}`, this.accountManager).then(
          () => {
            this.submiting = false
            this.$router.push({name: "AccountManagerList"})
            this.$toasted.success("Updated!")
          },
          err => {
            this.submiting = false
            this.$toasted.error(bodyTextOrRef(err))
          }
        )
      }
    },

    backView() {
      this.$router.push({name: "AccountManagerList"})
    },
  }
}
</script>

<style lang="scss" scoped>
.description {
  display: inline-block;
  max-height: 100px;
  max-width: 350px;
  overflow: auto;
}

.break-any {
  word-wrap: anywhere;
}
</style>
